// @flow
export const Primary: 'Primary' = 'Primary';
export const Secondary: 'Secondary' = 'Secondary';
export const Grey: 'Grey' = 'Grey';
export const White: 'White' = 'White';
export const Black: 'Black' = 'Black';
